import React, { forwardRef } from 'react';
import {
  PALETTE, FONT_SERIF, FONT_SANS, FONT_MONO,
  HaleMark, ToxIntelMark, Backplate, Card, Eyebrow, Headline, Body, Rule,
} from './primitives';

/* Asset 7 — LinkedIn Launch Graphic
 *
 * LinkedIn share image (1200×627 → viewBox 1200×627). Three brand
 * lockup tile + announcement headline. No stock photography. */

const VB_W = 1200;
const VB_H = 627;

const LinkedInLaunchAsset = forwardRef(function LinkedInLaunchAsset(_props, ref) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${VB_W} ${VB_H}`}
      width="100%"
      preserveAspectRatio="xMidYMid meet"
      role="img"
      aria-label="Hale × ToxIntel × Agyekum Group LinkedIn launch graphic"
    >
      <Backplate w={VB_W} h={VB_H} />

      {/* Brand row — three tiles, locked hierarchy */}
      <g transform="translate(56,56)">
        {/* HALE block */}
        <rect x={0} y={0} width={340} height={140} fill={PALETTE.HALE_RED} />
        <text
          x={170}
          y={86}
          textAnchor="middle"
          fill={PALETTE.HALE_INK}
          fontFamily='"Archivo Black",Impact,sans-serif'
          fontWeight={900}
          fontSize={84}
          letterSpacing={3}
        >
          HALE
        </text>

        {/* Divider */}
        <line x1={356} y1={20} x2={356} y2={120} stroke={PALETTE.RULE} strokeWidth={1} />

        {/* TOXINTEL serif */}
        <g transform="translate(384,0)">
          <Eyebrow x={0} y={28} text="Powered by" />
          <ToxIntelMark x={0} y={102} fontSize={56} />
        </g>

        {/* Divider */}
        <line x1={764} y1={20} x2={764} y2={120} stroke={PALETTE.RULE} strokeWidth={1} />

        {/* AG block */}
        <g transform="translate(792,0)">
          <Eyebrow x={0} y={28} text="Scientific review partner" />
          <text x={0} y={94} fill={PALETTE.SLATE} fontFamily={FONT_SERIF} fontWeight={700} fontSize={40}>
            The Agyekum Group
          </text>
        </g>
      </g>

      <Rule x1={56} x2={VB_W - 56} y={244} />

      {/* Headline */}
      <Eyebrow x={56} y={290} text="Pilot launch · 2026" />
      <Headline x={56} y={368} text="Independent product" size={56} />
      <Headline x={56} y={428} text="governance, built for modern brands." size={56} italic color={PALETTE.CORAL} />

      <Body
        x={56}
        y={480}
        size={18}
        color={PALETTE.MUTED}
        lineHeight={1.5}
        text={[
          'Hale Reviewed™ and Verified™ pathways. Independent scientific review.',
          'Portable retailer-ready documentation.',
        ]}
      />

      {/* Footer */}
      <text x={56} y={VB_H - 36} fill={PALETTE.MUTED} fontFamily={FONT_MONO} fontSize={11} letterSpacing={2}>
        HALE × TOXINTEL × THE AGYEKUM GROUP
      </text>
      <text x={VB_W - 56} y={VB_H - 36} textAnchor="end" fill={PALETTE.MUTED} fontFamily={FONT_MONO} fontSize={11} letterSpacing={2}>
        thehale.co · toxintel.tagc.us
      </text>
    </svg>
  );
});

export default LinkedInLaunchAsset;
